<template>
    <div class="px-6 py-2 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
      <div class="bg-gradient-to-b from-[#F8F6FF] to-white rounded-2xl h-full flex flex-col gap-4">
        <div
          class="flex-1 bg-white rounded-2xl overflow-hidden flex flex-col"
        >
          <!-- Header
          <div class="flex items-center justify-between px-4 py-3 border-b border-[#F0EFF6]">
            <h3 class="text-[1.25rem] font-semibold text-[#171717]">
              E-Tool© Module Guide
            </h3>
          </div> -->
  
          <!-- PDF Viewer -->
          <div class="flex-1 overflow-auto pdf-viewer">
            <VuePdfEmbed
              :source="pdfPath"
              class="pdf-embed"
            />
          </div>
        </div>
  
        <!-- Download Button -->
        <div class="flex justify-center">
          <button
            @click="downloadPdf"
            class="px-1.5 py-0.5 text-[10px] sm:px-2 sm:py-1 sm:text-xs md:px-2.5 md:py-1 md:text-sm lg:px-3 lg:py-1 lg:text-small rounded sm:rounded-md md:rounded-lg font-medium text-white hover:opacity-90 transition-opacity"
            style="background-color: #320177;"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import { useStepValidation } from '@/composables/useStepValidation';
  import VuePdfEmbed from 'vue-pdf-embed';
  
  // Step validation
  useStepValidation();
  
  // PDF path
  const pdfPath = computed(() => '/files/E-Tool Module Guide.pdf');
  
  // Download PDF
  const downloadPdf = () => {
    const link = document.createElement('a');
    link.href = pdfPath.value;
    link.download = 'E-Tool Module Guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  </script>
  
  <style scoped>
  /* PDF container spacing */
  .pdf-viewer {
    padding: 24px 32px;
    scrollbar-width: thin; /* Firefox */
  }
  
  /* Slim scrollbar - Chrome, Edge, Safari */
  .pdf-viewer::-webkit-scrollbar {
    width: 6px;
  }
  
  .pdf-viewer::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }
  
  .pdf-viewer::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* PDF pages styling */
  .pdf-embed canvas {
    display: block;
    margin: 0 auto 24px auto; /* space between pages */
    max-width: 1200px;
    width: 100% !important;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }
  </style>
  